import { useEffect, useState } from 'react';

export function useLinearProgressCalc(executionTimeSec: number, isNeedStartTimer: boolean = true) {
    const [completed, setCompleted] = useState<number>(0);

    useEffect(() => {
        if (isNeedStartTimer) {
            function progress() {
                setCompleted(oldCompleted => {
                    if (oldCompleted === 100) {
                        clearInterval(timer);
                    }

                    const diff = 10 / executionTimeSec; // 1% === (100% * 0.1s) / executionTimeSec, 0.1s - time for 1 step
                    return Math.min(oldCompleted + diff, 100);
                });
            }
            const timer = setInterval(progress, 100);
            return () => {
                clearInterval(timer);
            };
        } else {
            setCompleted(0);
        }
    }, [isNeedStartTimer]);

    return completed;
}
